import React from 'react'

const Post = ({ handleClick, title, text, date, name }) => (
  <div className="blog-post" onClick={handleClick}>
    <h3>{title}</h3>
    <div>{date}</div>
    <p>{text}</p>
    <div>{name}</div>
  </div>
)

export default Post
